// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3Poj_","list":"PatternAutocomplete_list__2_OIP"};